<div *ngIf="pager.totalPages>1" class="pagination-outer text-center pagination-margin">
    <ul class="pagination">

        <!-- first page -->
        <li *ngIf="pager.totalPages > 10 && pager.currentPage !== 1" class="page-item first-item">
            <a (click)="onChangeSetPage(1)" class="page-link">αρχικη</a>
        </li>

        <!-- previous page -->
        <li *ngIf="pager.currentPage !== 1" class="page-item">
            <a class="page-link" (click)="onChangeSetPage(pager.currentPage - 1)">
                << </a>
        </li>

        <li *ngIf="pager.currentPage > 3 && pager.totalPages > 5" class="page-item">
            <p class="dots">...</p>
        </li>

        <li *ngFor="let page Of pager.pages; let i=index;" [ngClass]="{active:pager.currentPage === page}" class="page-item">
            <a class="page-link" (click)="onChangeSetPage(page)">
                {{page}}</a>
        </li>

        <li *ngIf="pager.currentPage < pager.totalPages - 2 && pager.totalPages > 5" class="page-item">
            <p class="dots">...</p>
        </li>

        <!-- next page -->
        <li *ngIf="pager.currentPage !== items.totalPages" class="page-item">
            <a class="page-link" (click)="onChangeSetPage(pager.currentPage + 1)">
                >> </a>
        </li>

        <!-- last page -->
        <li *ngIf="pager.totalPages > 10 && (pager.currentPage !== pager.totalPages)" class="page-item last-item">
            <a (click)="onChangeSetPage(pager.totalPages)" class="page-link">Τελευταια</a>
        </li>

    </ul>
</div>